import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import logo from "../../assets/img/logo/tf_logo.svg";
import MobileMenu from "../MobileMenu";
import { useApi } from "../../middleware/middleware";
import SearchService from "../SearchService";
import axios from "axios";
import Topbar4 from "./Topbar4";
import searchIcon from "../../assets/img/icon/magnifier-icon.png";
import SearchPopup from "../SearchService/SearchPopup";

function MainMenu4Test() {
  // const { data, error, isLoading } = useApi('servecies_data', {});
  const { data, error, isLoading } = useApi("services_list", {});

  const {
    data: aboutData,
    error: error2,
    isLoading: isLoading2,
  } = useApi("about_data", {});

  const [location, setLocation] = useState(null);

  useEffect(() => {
    // get location from cache and if not available or expired then fetch from api
    const cachedLocation = JSON.parse(localStorage.getItem("location"));
    let currentTimestamp = Date.now();
    const expTime = 3 * 24 * 60 * 60 * 1000; // 3 days
    let isMounted = true; // to handle api when component unmount

    // if location data is available in cache and it is not expired
    if (cachedLocation && currentTimestamp - cachedLocation.timestamp < expTime)
      setLocation(cachedLocation.data);
    else {
      // fetch location from api
      axios
        .get(`${process.env.REACT_APP_API_URL}/get_ip_details`)
        .then((res) => {
          const { data } = res.data;
          // store location and created date in cache
          const locationToStore = {
            data,
            timestamp: currentTimestamp,
          };

          // incase component is unmounted so memory leak can be avoided
          if (isMounted) setLocation(data);

          localStorage.setItem("location", JSON.stringify(locationToStore));
        })
        .catch((err) => console.log(err));
    }

    return () => {
      isMounted = false;
    };
  }, []);

  return (
    <header className="header-wrap header-3 mt-1">
      
      <div className="container">
        <div className="row py-3 align-items-center justify-content-between">
          <div className=" mobile-menu-bar col-lg-3 col-xl-2 col-2 col-md-2 text-right d-in-flex align-items-center">
            <div className="col">
              <MobileMenu aboutData={aboutData} serviceData={data} />
            </div>
          </div>
          <div className="col-lg-12 col-md-10 col-10 d-flex justify-content-lg-between justify-content-end align-items-center ">
            <div className="logo">
              <Link to="/">
                <img src={logo} alt="Logo" height={80} width={140} className="d-md-none d-inline-block"/>
                <img src={logo} alt="Logo" height={60} className="d-none d-md-block"/>
              </Link>
            </div>
            <div className="d-flex align-items-end">
              <Topbar4/>
              <div className="d-flex justify-content-end align-items-center gap-2">
                <SearchPopup/>
                <Link to={'/request-quote'} className="header-btn nav-header-btn">
                    Request a Quote
                </Link>
              </div>
            </div>
          </div>

        </div>
      </div>
    </header>
  );
}

export default MainMenu4Test;
